import { MapUtils } from '../../../utility/map-utils.js';
import { VersionRange } from '../../core/version-range.js';
import {
  cloneListOrNull, DataModel, DataModelBuilder,
  isSameList, SerializationContext, SerializedData,
} from '../../dto/dto.js';

/**
 * @deprecated
 */
export class LegacyEventPromoCode extends DataModel {
  static readonly TYPE_ID: string = 'a805fed501f149e399f99343cc20327f';
  static readonly SCHEMA_VERSION: number = 2;

  constructor(
    public readonly uniqueId: string,
    public readonly eventId: string,
    public readonly ticketId: string[] | null,
    public readonly discount: number,
    public readonly description: string | null = null,
  ) {
    super();

    if(discount < 0 || discount > 100) {
      throw new Error('Invalid discount value');
    }
  }

  get $typeId(): string {
    return LegacyEventPromoCode.TYPE_ID;
  }

  get $schemaVersion(): VersionRange {
    return VersionRange.between(1, LegacyEventPromoCode.SCHEMA_VERSION);
  }

  static fromMap(data: SerializedData, context: SerializationContext): LegacyEventPromoCode {
    return new LegacyEventPromoCode(
        MapUtils.get<string>(data, 'uniqueId'),
        MapUtils.get<string>(data, 'eventId'),
        MapUtils.getListOrNull<string>(data, 'ticketId', (e) => e as string),
        MapUtils.get<number>(data, 'discount'),
        MapUtils.getOrNull<string>(data, 'description'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'eventId': this.eventId,
      'ticketId': this.ticketId,
      'discount': this.discount,
      'description': this.description,
    };
  }

  clone(): this {
    return new LegacyEventPromoCode(
        this.uniqueId,
        this.eventId,
        cloneListOrNull(this.ticketId),
        this.discount,
        this.description,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.eventId === this.eventId &&
        isSameList(other.ticketId, this.ticketId) &&
        other.discount === this.discount &&
        other.description === this.description;
  }
}

export class LegacyEventPromoCodeBuilder extends DataModelBuilder<LegacyEventPromoCode> {
  build(context: SerializationContext, map: SerializedData): LegacyEventPromoCode {
    return LegacyEventPromoCode.fromMap(map, context);
  }

  migrateToCurrentSchemaVersion(context: SerializationContext, map: SerializedData): SerializedData | null {
    const versionRange = MapUtils.getVersionRange(map);

    if(versionRange.contains(LegacyEventPromoCode.SCHEMA_VERSION)) {
      return map;
    }
    if(versionRange.isGreaterThan(LegacyEventPromoCode.SCHEMA_VERSION)) {
      return null; // This data comes from the FUTURE. We have no idea how to migrate it.
    }

    let version = versionRange.to;

    // In version 2, we added the [ticketId] field.
    if(version < 2) {
      MapUtils.setIfNullOrUndefined(map, 'ticketId', []);
      version = 2;
    }

    map['$schema_version'] = VersionRange.encodedExactly(version);
    return map;
  }
}
